export const slideDuration = 300;
export const fadeInDuration = 200;
export const fadeOutDuration = 200;
export const fadeOutDelay = 200;
